<!-- No Data Template -->
<ng-template #no_data_template
  let-depth="depth">
  <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContent">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentNoDataContainer(depth)">
        <span [class]="FlatModels.TreeDesignModels.TreeDragNodeNoDataText">
          {{ 'global.no_data' | translate }}
        </span>
      </div>
    </div>
  </div>
</ng-template>

<!-- Node Template -->
<ng-template #node_template
  let-templateNodeTree="templateNodeTree"
  let-typedNodeExpanded="typedNodeExpanded"
  let-typedRouteElements="typedRouteElements"
  let-parentNode="parentNode"
  let-node="node"
  let-page="page"
  let-disabledParent="disabledParent">
  @if(page) {
    @if (typedRouteElements[node.id]; as routeElement) {
      <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
        @if ({
          selected: nodeSharedFacade.isNodeSelected$(node.id) | async,
          current: nodeSharedFacade.isNodeCurrent$(node.id) | async,
          hasBulkEditNode: nodeSharedFacade.hasBulkEditNode$(node.id) | async,
          routeElement: nodeSharedFacade.currentSelectedRouteElement$ | async
        }; as selectionData) {
          <div [id]="'tnt-' + node.id"
            [class]="FlatModels.TreeDesignModels.TreeDragNodeContent"
            [class.current]="!selectionData.hasBulkEditNode && routeElement.id === selectionData.routeElement?.id"
            [class.selected]="selectionData.selected"
            [class.disabled]="disabledParent || node.hidden === true"
            (click)="onNodeSelect(routeElement)">
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(routeElement.depth)">
              @if (routeElement.depth < 4) {
                <button medsurf-design-input-button
                  [id]="'node_toggle_' + node.id"
                  [title]="(!typedNodeExpanded[node.id] ? 'global.node_toggle_open' : 'global.node_toggle_close') | translate"
                  [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
                  [iconClass]="(!typedNodeExpanded[node.id] ? FlatModels.ButtonDesignModels.ButtonDefaultIcons.RIGHT : FlatModels.ButtonDesignModels.ButtonDefaultIcons.DOWN)"
                  [disabled]="node.children.length === 0"
                (click)="onNodeExpand(node)"></button>
              }
            </div>
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentImageContainer">
              @if (page.type === FlatModels.PageEntityModels.PageType.enum.Slide && (slideAuthorFacade.media$(page.thumbnailMedia) | async); as media) {
                <img [style]="FlatModels.TreeDesignModels.TreeDragNodeImageHeightStyle"
                  [src]="mediaControlService.getUrl(media, 'thumbnail') || '/assets/images/no-image.png'"
                  [alt]="media?.name || 'global.error_loading_image' | translate" />
              }
              @if (page.type !== FlatModels.PageEntityModels.PageType.enum.Slide || !page.thumbnailMedia) {
                <i
                  [style.color]="getColor(page.themeColor)"
                  class="{{ FlatModels.PageEntityModels.PageTypeAndDepthIcon(page.type, routeElement.depth) }} {{ getSolid(page.themeColor) }}">
                </i>
              }
            </div>
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
              <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText"
                [title]="page.title">
                {{ page.title }}
              </span>
            </div>
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentAttributesContainer">
              @if (node.hidden === true) {
                <medsurf-design-content-chip
                  [tooltipLabel]="'global.node_not_visible' | translate"
                  [styleClass]="'p-menu_icon'">
                  <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.EYE_SLASH"></i>
                </medsurf-design-content-chip>
              }
            </div>
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentAttributesContainer">
              @if (node.restricted === true) {
                <medsurf-design-content-chip
                  [tooltipLabel]="'global.node_is_restricted' | translate"
                  [styleClass]="'p-menu_icon'">
                  <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.LOCK"></i>
                </medsurf-design-content-chip>
              }
            </div>
          </div>
        }
        @if (![FlatModels.PageEntityModels.PageType.enum.Slide, FlatModels.PageEntityModels.PageType.enum.Training].includes(page.type)) {
          @let childNodes = nodeSharedFacade.nodeByIds$(node.children) | async | sortBy_shared:'asc':'position';

          <div [hidden]="!typedNodeExpanded[node.id]"
            [class]="FlatModels.TreeDesignModels.TreeDragNodeContentContainer">
            @if (node.children.length === 0) {
            <ng-container *ngTemplateOutlet="no_data_template;context:{
                          depth: routeElement.depth + 1}"></ng-container>
            }
            @if (childNodes.length === 0) {
              @for (i of node.children; track i) {
                <p-skeleton [height]="FlatModels.TreeDesignModels.TreeDragNodeSkeletonHeight"
                  class="cursor-wait"
                  >
                </p-skeleton>
              }
            }
            @if (childNodes.length > 0) {
              <div>
                @for (childNode of childNodes; track trackByNode($index, childNode)) {
              <ng-container *ngTemplateOutlet="override_node_template || node_template;context:{
                            templateNodeTree,
                            typedNodeExpanded,
                            typedRouteElements,
                            parentNode: node,
                            node: childNode,
                            page: slideAuthorFacade.page$(childNode.page) | async,
                            disabledParent: disabledParent || node.hidden === true}">
                  </ng-container>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  }
</ng-template>

<!-- Menu Template -->
<ng-template #menu_template
  let-templateNodeTree="templateNodeTree"
  let-typedNodeExpanded="typedNodeExpanded"
  let-typedRouteElements="typedRouteElements"
  let-elearnings="elearnings">
  <div [class]="FlatModels.TreeDesignModels.TreeDragulaNode">
    @for (elearning of elearnings; track trackByNode($index, elearning)) {
      <ng-container *ngTemplateOutlet="override_node_template || node_template,context:{
                    templateNodeTree,
                    typedNodeExpanded,
                    typedRouteElements,
                    parentNode: undefined,
                    node: elearning,
                    page: slideAuthorFacade.page$(elearning.page) | async,
                    disabledParent: false}">
      </ng-container>
    }
  </div>
</ng-template>

<!-- Content -->
@if ({
  elearnings: nodeSharedFacade.elearnings$ | async | sortBy_shared:'asc':'position',
  typedNodeExpanded: slideAuthorFacade.typedNodeExpanded$ | async,
  typedRouteElements: nodeSharedFacade.typedRouteElements$ | async
}; as nodeData) {
  <div class="w-full overflow-hidden"
    >
  <ng-container *ngTemplateOutlet="override_menu_template || menu_template, context: {
                templateNodeTree: this,
                typedNodeExpanded: nodeData.typedNodeExpanded,
                typedRouteElements: nodeData.typedRouteElements,
                elearnings: nodeData.elearnings}">
    </ng-container>
  </div>
}